import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const UNIT_META = {
  frozen: {
    key: "frozen",
    name: "Frozen Unit",
    tag: "FRZ",
    accent: "#38bdf8",
    products: [
      "Frozen Green Peas",
      "Frozen Sweet Corn",
      "Frozen Carrot",
      "Frozen Cauliflower",
    ],
  },
  flour: {
    key: "flour",
    name: "Roller Flour Unit",
    tag: "FLR",
    accent: "#f59e0b",
    products: ["Atta", "Maida", "Suji", "Rawa", "Bran"],
  },
  dehydration: {
    key: "dehydration",
    name: "Dehydration Unit",
    tag: "DHY",
    accent: "#a3e635",
    products: [
      "Dried Potato Chips",
      "Onion Flakes",
      "Macaroni",
      "Fusili Pasta",
      "Penne Pasta",
    ],
  },
  besan: {
    key: "besan",
    name: "Besan Unit",
    tag: "BSN",
    accent: "#facc15",
    products: ["Besan"],
  },
};
